import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, isRef as _isRef, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "notice-list"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "notice-list"
};
import { useSettingsStore } from '@/store/modules/settings';
import { translate } from '@/i18n';

import { inject, ref, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
// import { getList } from '@/api/notice'
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const $baseMessage = inject('$baseMessage');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const activeName = ref('notice');
    const notices = ref([]);
    const badge = ref(undefined);
    // const fetchData = async () => {
    //   const {
    //     data: { list, total },
    //   } = await getList()
    //   notices.value = list
    //   badge.value = total === 0 ? undefined : total
    // }
    nextTick(() => {
      // if (theme.value.showNotice) fetchData()
    });
    const handleClick = () => {
      // fetchData()
    };
    const handleClearNotice = () => {
      badge.value = undefined;
      notices.value = [];
      $baseMessage('清空消息成功', 'success', 'vab-hey-message-success');
    };
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_badge = _resolveComponent("el-badge");
      return _unref(theme).showNotice ? (_openBlock(), _createBlock(_component_el_badge, {
        key: 0,
        type: "danger",
        value: _unref(badge)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_popover, {
          placement: "bottom",
          trigger: "hover",
          width: 300
        }, {
          reference: _withCtx(() => [_createVNode(_component_vab_icon, {
            icon: "notification-line"
          })]),
          default: _withCtx(() => [_createVNode(_component_el_tabs, {
            modelValue: _unref(activeName),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(activeName) ? activeName.value = $event : null),
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: _unref(translate)('通知'),
              name: "notice"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notices), (item, index) => {
                  return _openBlock(), _createElementBlock("li", {
                    key: index
                  }, [_createVNode(_component_el_avatar, {
                    size: 45,
                    src: item.image
                  }, null, 8, ["src"]), _createElementVNode("span", {
                    innerHTML: item.notice
                  }, null, 8, _hoisted_2)]);
                }), 128))])]),
                _: 1
              })])]),
              _: 1
            }, 8, ["label"]), _createVNode(_component_el_tab_pane, {
              label: _unref(translate)('邮件'),
              name: "email"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notices), (item, index) => {
                  return _openBlock(), _createElementBlock("li", {
                    key: index
                  }, [_createVNode(_component_el_avatar, {
                    size: 45,
                    src: item.image
                  }, null, 8, ["src"]), _createElementVNode("span", null, _toDisplayString(item.email), 1)]);
                }), 128))])]),
                _: 1
              })])]),
              _: 1
            }, 8, ["label"])]),
            _: 1
          }, 8, ["modelValue"]), _createElementVNode("div", {
            class: "notice-clear",
            onClick: handleClearNotice
          }, [_createVNode(_component_el_button, {
            text: "",
            type: "primary"
          }, {
            default: _withCtx(() => [_createVNode(_component_vab_icon, {
              icon: "close-circle-line"
            }), _createElementVNode("span", null, _toDisplayString(_unref(translate)('清空消息')), 1)]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["value"])) : _createCommentVNode("", true);
    };
  }
});